import { Placeholder } from '@sitecore/common';
import { Stack } from '@sparky';

export const ButtonLineUp = () => {
  return (
    <Stack direction={{ initial: 'column', md: 'row' }} gap="5" wrap>
      <Placeholder name="jss-buttons" />
    </Stack>
  );
};

export default ButtonLineUp;
